import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import { InfoRow } from './InfrastructureSectionPanel';

const InfrastructureOsPanel = ({ data }) => (
    <Row className="g-3">
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Host</div>
                    <InfoRow label="Hostname" value={data.hostname} />
                    <InfoRow label="Type" value={data.type} />
                    <InfoRow label="Platform" value={data.platform} />
                    <InfoRow label="Release" value={data.release} />
                    <InfoRow label="Architecture" value={data.arch} />
                    <InfoRow label="Uptime" value={data.uptime?.formatted} />
                    <InfoRow label="Temp Dir" value={data.tmpDir} />
                </Card.Body>
            </Card>
        </Col>
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Memory</div>
                    <InfoRow label="Total" value={data.memory?.total} />
                    <InfoRow label="Free" value={data.memory?.free} />
                    <InfoRow label="Used %" value={data.memory?.usedPercent} />
                </Card.Body>
            </Card>
            {data.userInfo && (
                <Card className="border-0 bg-light mt-3">
                    <Card.Body className="py-2 px-3">
                        <div className="small fw-semibold mb-2 text-secondary">User</div>
                        <InfoRow label="Username" value={data.userInfo.username} />
                        <InfoRow label="UID" value={data.userInfo.uid} />
                        <InfoRow label="Shell" value={data.userInfo.shell} />
                    </Card.Body>
                </Card>
            )}
        </Col>
        {data.networkInterfaces && Object.keys(data.networkInterfaces).length > 0 && (
            <Col xs={12}>
                <Card className="border-0 bg-light">
                    <Card.Body className="py-2 px-3">
                        <div className="small fw-semibold mb-2 text-secondary">Network Interfaces</div>
                        <div className="table-responsive">
                            <Table size="sm" className="mb-0 small">
                                <thead>
                                    <tr>
                                        <th>Interface</th>
                                        <th>Address</th>
                                        <th>Family</th>
                                        <th>Internal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.networkInterfaces).flatMap(([iface, addrs]) =>
                                        (Array.isArray(addrs) ? addrs : [addrs]).map((addr, i) => (
                                            <tr key={`${iface}-${i}`}>
                                                <td className="text-muted">{iface}</td>
                                                <td>{addr.address}</td>
                                                <td>{addr.family}</td>
                                                <td>{addr.internal ? 'Yes' : 'No'}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        )}
    </Row>
);

export default InfrastructureOsPanel;
